<!-- This is the Mein Dienst Dienstabschnitts Display -->
<template>
  <div v-if="duty" class="duty-activities full-width">
    <div v-if="dutyActivities" class="full-width">
      <div v-if="showDutyTitle" class="pl-6 py-2 text-h6">Dienst {{ duty.dutyname }}, {{ dutyDate }}</div>
      <v-divider v-if="showDutyTitle"></v-divider>
      <div v-if="!dutyActivities || dutyActivities.length === 0" class="pa-2 caption">
        {{ $t('noDutyActivities') }}
      </div>
      <template v-else>
        <div v-for="da in dutyActivities" :key="da.id" :style="cardStyle" :class="dutyActivityClass(da)" @click.prevent.stop="selectDutyActivity(da)">
          <div style="border-left: 10px solid transparent">
            <duty-activity
              :duty="duty"
              :dutyActivity="da"
              :isCollapsed="isCollapsed(da)"
              :isParent="true"
              :showBottomBorder="!hideDutyBottomBorder"
              @toggleCollapseState="toggleDutyActivity(da)"
              @displayTrainTeam="displayTrainTeam"
            ></duty-activity>
          </div>

          <!-- expanded duty activities -->
          <v-expand-transition>
            <div v-if="hasTrueChildren(da) && !isCollapsed(da)">
              <div
                v-for="(dutyActivity, i) in da.children"
                :key="dutyActivity.id + '_'"
                @click.prevent.stop="selectDutyActivity(dutyActivity)"
                :style="childStyle(i)"
                class="duty-activity-child"
              >
                <duty-activity
                  :duty="duty"
                  :dutyActivity="dutyActivity"
                  :nextDutyActivity="i < da.children.length - 1 ? da.children[i + 1] : null"
                  :isParent="false"
                  :isCollapsed="isCollapsed(dutyActivity)"
                  :class="{ emphasizedListItemColor: dutyActivity.id === selectedDutyActivity.id }"
                  :showBottomBorder="!hideDutyActivityBottomBorder"
                  @toggleCollapseState="toggleDutyActivity(dutyActivity)"
                  @displayTrainTeam="displayTrainTeam"
                ></duty-activity>
              </div>
            </div>
          </v-expand-transition>
        </div>
      </template>
    </div>
    <div v-else class="mx-0">
      <v-card flat>
        <v-card-text>{{ $t('myDuty.noActivities') }}</v-card-text>
      </v-card>
    </div>
    <train-team v-model="showTrainTeamDialog" :trainNr="trainNr" :trainTeam="trainTeam"></train-team>
  </div>
</template>

<script>
import commonMixin from '@/mixins/common';
import dutyMixin from '../common/dutyMixin';
import DutyActivity from './DutyActivity.vue';
import Vue from 'vue';
import TrainTeam from '@/modules/myDuties/TrainTeam/TrainTeam.vue';
import dateUtils from '@/common/dateUtils';

export default {
  name: 'DutyActivities',
  mixins: [commonMixin, dutyMixin],
  components: {
    DutyActivity,
    TrainTeam,
  },
  props: {
    duty: {
      type: Object,
    },
    dutyActivities: { type: Array, default: () => [] },
    mergeAllDuties: { type: Boolean, default: true },
  },

  data() {
    return {
      selectedDutyActivity: {},
      collapsedDutyActivities: {},
      showTrainTeamDialog: false,
      trainNr: null,
      trainTeam: [],
    };
  },
  mounted() {
    this.toggleAll();
  },
  computed: {
    cardStyle() {
      return this.hideDutyActivityBorder ? '' : `border:1px solid ${this.darkMode ? '#303030' : '#f0f0f0'}`;
    },
    showDutyTitle() {
      return !!this.mx_moduleConfig.showDutyTitle;
    },
    hideDutyActivityBorder() {
      return !!this.mx_moduleConfig.hideDutyActivityBorder;
    },
    dutyDate() {
      return dateUtils.formatAsLocaleShortDate(dateUtils.parseISOString(this.duty.day));
    },
    hideDutyBottomBorder() {
      return !!this.mx_moduleConfig.hideDutyBottomBorder;
    },
    hideDutyActivityBottomBorder() {
      return !!this.mx_moduleConfig.hideDutyActivityBottomBorder;
    },
  },
  methods: {
    displayTrainTeam(trainNr, trainTeam) {
      console.debug('displayTrainTeam', trainNr, trainTeam);
      this.showTrainTeamDialog = true;
      this.trainNr = trainNr;
      this.trainTeam = trainTeam;
    },
    selectDutyActivity(da) {
      this.selectedDutyActivity = da;
      this.$emit('onDutyActivitySelected', da);
    },
    hasTrueChildren(dutyActivity) {
      return dutyActivity && dutyActivity.children && dutyActivity.children.length > 1;
    },

    isCollapsed(dutyActivity) {
      return this.collapsedDutyActivities[dutyActivity.id] === true;
    },
    collapseAll() {
      if (!this.dutyActivities) return;
      if (this.dutyActivities) {
        this.dutyActivities.forEach((da) => {
          if (this.hasTrueChildren(da)) {
            this.collapseDutyActivity(da);
          }
        });
      }
    },
    expandAll() {
      this.collapsedDutyActivities = {};
    },
    toggleAll() {
      if (this.mergeAllDuties) {
        this.collapseAll();
      } else {
        this.expandAll();
      }
    },
    collapseDutyActivity(dutyActivity) {
      Vue.set(this.collapsedDutyActivities, dutyActivity.id, true);
    },
    toggleDutyActivity(dutyActivity) {
      let isCollapsed = this.isCollapsed(dutyActivity);
      if (isCollapsed) {
        Vue.delete(this.collapsedDutyActivities, dutyActivity.id);
      } else {
        Vue.set(this.collapsedDutyActivities, dutyActivity.id, true);
      }
    },
    dutyActivityClass(dutyActivity) {
      if (dutyActivity.id === this.selectedDutyActivity.id) {
        return 'emphasizedListItemColor';
      }
      return null;
    },

    childStyle(index) {
      return index === 0 ? `border-top:1px solid ${this.darkMode ? '#303030' : '#f2f2f2'}` : '';
    },
  },
  watch: {
    mergeAllDuties(newValue, oldValue) {
      this.toggleAll();
    },
    dutyActivities(newValue, oldValue) {
      this.toggleAll();
    },
  },
};
</script>
<style scoped>
.selected-light {
  background: #82cbf8 !important;
}

.selected-dark {
  background: #202020;
}
</style>
